import React from "react";
import { createPortal } from "react-dom";
import "./index.scss";

/** Full-viewport overlay; portals to `document.body` so parent `transform` (e.g. enter animations) cannot shrink the fixed containing block. */
export function FullPageLoadingBarOverlay(): JSX.Element {
  const overlay = (
    <div
      className="full-page-loading-bar__overlay"
      role="progressbar"
      aria-busy="true"
      aria-label="Loading, please wait"
    >
      <div className="full-page-loading-bar__bar" aria-hidden />
    </div>
  );
  if (typeof document !== "undefined" && document.body) {
    return createPortal(overlay, document.body);
  }
  return overlay;
}
